module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "color": "white"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "5px",
      "text-align": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px",
      "margin-left": "10px"
    }
  }, [_vm._v("\n        자주 접속하는 사이트\n    ")]), _vm._v(" "), _c('div', [_c('ul', [_c('li', [_c('div', {
    staticStyle: {
      "padding": "3px 10px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "height": "30px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "30px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": require("./../assets/icon/icon-jinblog.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "1",
      "margin-left": "10px"
    }
  }, [_vm._v("\n                            진블로그\n                        ")])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticStyle: {
      "padding": "3px 10px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "height": "30px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "30px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": require("./../assets/icon/icon-naver.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "1",
      "margin-left": "10px"
    }
  }, [_vm._v("\n                            네이버\n                        ")])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticStyle: {
      "padding": "3px 10px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "height": "30px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "30px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": require("./../assets/icon/icon-daum.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "1",
      "margin-left": "10px"
    }
  }, [_vm._v("\n                            다음\n                        ")])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticStyle: {
      "padding": "3px 10px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "height": "30px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "30px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": require("./../assets/icon/icon-grap.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "1",
      "margin-left": "10px"
    }
  }, [_vm._v("\n                            그랩\n                        ")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d349afe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppList.vue
// module id = 152
// module chunks = 1